"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4281],{

/***/ 34281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_NearByVenueView; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(Text);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./src/DAO/index.js + 12 modules
var DAO = __webpack_require__(90793);
// EXTERNAL MODULE: ./src/components/molecules/index.js + 37 modules
var molecules = __webpack_require__(53732);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/profile/components/NearByVenueView/VenueList.js






var VenueList = function VenueList(props) {
  var items = props.items,
      isMobileVersion = props.isMobileVersion,
      category = props.category;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [styles.container, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
      horizontal: false,
      items: items,
      showYear: false,
      isLoading: false,
      category: category,
      showInView: false,
      isMobileVersion: isMobileVersion
    })
  });
};

var styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch",
    marginHorizontal: 16
  }
});
/* harmony default export */ var NearByVenueView_VenueList = (VenueList);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
;// CONCATENATED MODULE: ./src/modules/profile/components/NearByVenueView/index.js













var PAGE_SIZE = 5;

var NearByVenueView = function NearByVenueView(props) {
  var isMobileVersion = props.isMobileVersion,
      category = props.category;
  var _props$item = props.item,
      longitude = _props$item.longitude,
      latitude = _props$item.latitude,
      startDate = _props$item.startDate,
      endDate = _props$item.endDate,
      id = _props$item.id;

  var _useState = (0,react.useState)([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = (0,react.useState)(0),
      totalCount = _useState2[0],
      setTotalCount = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      lastPageCount = _useState3[0],
      setLastPageCount = _useState3[1];

  var _useState4 = (0,react.useState)(0),
      pageIndex = _useState4[0],
      setPageIndex = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isLoading = _useState5[0],
      setIsLoading = _useState5[1];

  var isShowLoadMore = items.length < totalCount;
  (0,react.useEffect)(function () {
    getNearByVenues();
  }, [id]);

  var getNearByVenues = function getNearByVenues() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (isLoading) return;
    setIsLoading(true);
    var range =  false ? 0 :  false ? 0 :  true ? 10 : 0;
    var params = {
      range: range,
      longitude: longitude,
      latitude: latitude,
      pageSize: 5,
      pageIndex: page,
      nearByVenueId: id,
      categoryType: props.category
    };
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      if (page == 0) {
        setItems(result.data);
      } else {
        setItems([].concat((0,toConsumableArray/* default */.Z)(items), (0,toConsumableArray/* default */.Z)(result.data)));
      }

      setLastPageCount(result.data.length);
      setTotalCount(result.totalCount);
      setIsLoading(false);
    })["catch"](function (error) {
      setIsLoading(false);
    });
  };

  var onLoadMore = function onLoadMore() {
    if (lastPageCount == PAGE_SIZE && !isLoading) {
      setPageIndex(pageIndex + 1);
      getNearByVenues(pageIndex + 1);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [NearByVenueView_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: isMobileVersion ? "px-4" : "",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: [NearByVenueView_styles.itemContainer, isMobileVersion ? {
          height: 32,
          width: 120,
          marginTop: 30
        } : {}],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [NearByVenueView_styles.title, isMobileVersion ? {
            fontSize: 12,
            lineHeight: 12
          } : {}],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "Nearby"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [NearByVenueView_styles.description, isMobileVersion ? {
            fontSize: 12,
            lineHeight: 12
          } : {}],
          children: totalCount
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NearByVenueView_VenueList, {
      items: items,
      category: category,
      isMobileVersion: isMobileVersion
    }), isShowLoadMore && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      style: isMobileVersion ? NearByVenueView_styles.mobileLoadMoreButtonContainer : NearByVenueView_styles.loadMoreButtonContainer,
      onPress: onLoadMore,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [NearByVenueView_styles.buttonText, isMobileVersion && {
          fontSize: 12,
          lineHeight: 12
        }],
        children: "VIEW MORE"
      })
    })]
  });
};

var NearByVenueView_styles = StyleSheet_default().create({
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 25,
    marginLeft: 16,
    marginBottom: 30,
    height: 50,
    width: 200,
    backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-gray1")
  },
  container: {
    alignSelf: "stretch"
  },
  title: {
    color: "white",
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  description: {
    color: (0,formatHelpers/* getClass */.ll)("text-gray2"),
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    marginLeft: 8,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: (0,formatHelpers/* getClass */.ll)("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: (0,formatHelpers/* getClass */.ll)("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  buttonText: {
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    textAlign: "center"
  }
});
/* harmony default export */ var components_NearByVenueView = (NearByVenueView);

/***/ })

}]);